import { FormularioTrader } from './formulario-trader.page';
import { FormularioTraderProvider } from 'projects/core/src/lib/core/provider/FormularioTraderProvider';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { FormularioTraderModel } from 'projects/core/src/lib/core/model/FormularioTraderModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';

export class FormularioTraderViewModel {
    constructor() {}

    context: FormularioTrader
    formularioTraderProvider = new FormularioTraderProvider()

    getContext(): FormularioTrader {
        return this.context
    }

    setContext(context: FormularioTrader) {
        this.context = context
    }

    async getEstruturaFormulario() {
        let retorno = await this.formularioTraderProvider.estruturaFormulario()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {}
    }

    async enviaFormulario(formulario: FormularioTraderModel) {
        let retorno = await this.formularioTraderProvider.enviaFormulario(formulario)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {
            throw new Error(e.message)
        }
    }

    async getRespostasFormulario() {
        let retorno = await this.formularioTraderProvider.respostas()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                return retorno.data
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {}
    }

    async apiResultadoFormulairoTrader() {
        let retorno = await this.formularioTraderProvider.resultado()
        retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
        if (retorno.status == ResponseModel.STATUS_OK) {
            return retorno.data
        } else {
            throw Error()
        }
    }
}